
import { videoUploadTypes, isOverLimit, isFileTypeLegal } from './utils';

export default {
  props: {
    setVideo: {
      type: Function,
      default: function _default() {}
    },

    uploadSuccess: {
      type: Function,
      default: function _default() {}
    },

    resetProgress: {
      type: Function,
      default: function _default() {}
    },

    uploading: {
      type: Boolean,
      default: false
    },

    maxSize: {
      type: Number,
      default: 50
    },

    uploadUrl: {
      type: String,
      default: ''
    },

    uploadData: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },

  data: function data() {
    return {
      fileList: [],
      videoUploadTypes: videoUploadTypes()
    };
  },


  computed: {
    accept: function accept() {
      return '.mp4,.avi,.mov,.flv';
    }
  },

  mounted: function mounted() {
    this.$refs['video-uploader'].addEventListener('drop', this.handleDrop);
  },


  methods: {
    handleDrop: function handleDrop(e) {
      var _this = this;

      if (!e.dataTransfer.files) return;

      [].forEach.call(e.dataTransfer.files, function (file) {
        if (!file || !file.type || !isFileTypeLegal(file.type, _this.videoUploadTypes)) {
          _this.$message({
            message: '\u683C\u5F0F\u4E0D\u7B26\u5408\u8981\u6C42\uFF0C\u8BF7\u91CD\u65B0\u4E0A\u4F20',
            type: 'warning'
          });
        }
      });
    },
    handleRemove: function handleRemove() {
      this.resetFileListAndVideo();
    },
    handleSuccess: function handleSuccess(response, file, fileList) {
      if (response.code === 0) {
        this.uploadSuccess(response.data.id);
      } else {
        this.uploadError();
      }
    },
    handleError: function handleError() {
      this.uploadError();
    },
    handleChange: function handleChange(file, fileList) {
      if (isOverLimit(file.size, this.maxSize * 1024 * 1024)) {
        this.uploadError('\u89C6\u9891\u5927\u5C0F\u4E0D\u80FD\u8D85\u8FC7 ' + this.maxSize + 'mb');
        return;
      }

      this.fileList = [file];
      if (!this.uploading) {
        this.setVideo(file);
      }
    },
    handleBeforeRemove: function handleBeforeRemove() {
      if (this.uploading) {
        this.$message({ message: '处理视频中', type: 'warning' });
        return false;
      }
      return true;
    },
    resetFileListAndVideo: function resetFileListAndVideo() {
      this.fileList = [];
      this.setVideo(null);
    },
    uploadError: function uploadError(msg) {
      var _this2 = this;

      this.$message({
        message: msg || '上传失败，请重新尝试',
        type: 'warning'
      });
      this.resetProgress();
      this.$nextTick(function () {
        _this2.resetFileListAndVideo();
      });
    },
    submit: function submit() {
      this.$refs.upload.submit();
    }
  }
};